/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import PlanListView from '../../view/pages/plan/ListView'
import HotelOptionsStore from '../../store/options/HotelOptionsStore'
import PlanAction from '../../action/plan'
import PlanSearchStore from '../../store/plan/PlanSearchStore'
import PlansStore from '../../store/plan/PlansStore'
import PlanStore from '../../store/plan/PlanStore'
import PlanPaginationStore from '../../store/plan/PlanPaginationStore'
import SessionAction from '../../action/session'
import NProgress from 'nprogress'

class ListContainer extends Component {
  static getStores() {
    return [HotelOptionsStore, PlanSearchStore, PlansStore, PlanStore, PlanPaginationStore]
  }

  static calculateState(prevState, props) {
    return {
      hotel_options: HotelOptionsStore.getState(),
      plans: PlansStore.getState(),
      plan: PlanStore.getState(),
      pagination: PlanPaginationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()

    const id = this.state.match.params.id
    if (id) {
      await PlanAction.fetchOne(id)
      NProgress.done()
      return
    }
    await PlanAction.onSearch(this.state.pagination)
    await SessionAction.fetchUserHotels()
    NProgress.done()
  }

  render() {
    return PlanListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
